module.exports = __webpack_public_path__ + "static/media/bocongthuong1.ce5cd70e.svg";